import type { FC, MouseEventHandler } from 'react'
import { MinimalistButton } from '@g4g/ui/src/internal/buttons/MinimalistButton'
import { FunnelIcon, ArrowsUpDownIcon } from '@heroicons/react/24/outline'

const MobileHeaderButton: FC<{
  btnType: 'filter' | 'sort'
  active?: boolean
  children?: React.ReactNode
  onClick?: MouseEventHandler<HTMLButtonElement>
  'data-cy'?: string
}> = ({ active, children, onClick, btnType, 'data-cy': dataCy }) => (
  <MinimalistButton
    data-cy={dataCy}
    className="flex items-center justify-center w-1/2 text-white h-11"
    mainColor="#30323b"
    buttonText={children}
    onClick={onClick}
    textColor={active ? 'white' : '#d1d1d1'}
    fill
    icon={
      <div className="w-5 h-5 mr-2">
        {btnType === 'filter' ? (
          <FunnelIcon className="w-5 h-5" />
        ) : (
          <ArrowsUpDownIcon className="w-5 h-5" />
        )}
      </div>
    }
  />
)

export default MobileHeaderButton
